import {BirthdayList} from "./../../models/BirthdayList";

let birthdayListsApi = {
    async get(filters, page=1, token, companyId){
        let response = await window.axios.get('/api/birthday-lists', {
            params:{
                api_token:token,
                company_logged:companyId,
                page: page,
                ...filters
            }
        });
        
        return response.data;
    },
    async find(id, token, companyId){
        let response = await window.axios.get('/api/birthday-lists/'+id, {
            params:{
                api_token:token,
                company_logged:companyId
            }
        });
        return new BirthdayList(response.data);
    },
    async create(birthdayList, token, companyId){
        let response = await window.axios.post('/api/birthday-lists', birthdayList, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new BirthdayList(response.data);
    },
    async edit(birthdayList, token, companyId){
        let response = await window.axios.put('/api/birthday-lists/'+birthdayList.id, birthdayList, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new BirthdayList(response.data);
    },
    async delete(birthdayList, token, companyId){
        let response = await window.axios.delete('/api/birthday-lists/'+birthdayList.id, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return !!response.data.success;
    },
    async downloadContactsSheet(birthdayList, token, companyId){
        let response = await window.axios.get('/api/birthday-lists/'+birthdayList.id+'/contacts-sheet', {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return response.data.url;
    },
    async downloadFiredSheet(birthdayList, token, companyId){
        let response = await window.axios.get('/api/birthday-lists/'+birthdayList.id+'/fired-sheet', {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return response.data.url;
    },
    async sentToIntegration(birthdayList, token, companyId){
        let response = await window.axios.post('/api/birthday-lists/'+birthdayList.id+'/to-integration', null, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return response.data;
    },
    async findByCompanyId(id, token, companyId){
        let response = await window.axios.get('/api/'+companyId+'/birthday-list', {
            params:{
                api_token:token,
                company_logged:companyId
            }
        });
        return new BirthdayList(response.data);
    }
}

export default birthdayListsApi
